import { Injectable, computed, inject } from '@angular/core';
import { AuthStore } from '../../login/store/auth.store';
import { ClientModules, Actions } from '../enum';

@Injectable({ providedIn: 'root' })
export class PermissionService {
  private _authStore = inject(AuthStore);
  currentUser = this._authStore.currentUser();

  userPermissions = computed(() => {
    if (!this.currentUser?.userRole?.permissions?.desktop) {
      return {
        changeRole: false,
        edit: false,
        delete: false,
      };
    }

    const userManagementPermission =
      this.currentUser.userRole.permissions.desktop.find(
        (p) => p.resource === ClientModules.USERS_MANAGEMENT,
      );

    return {
      changeRole:
        userManagementPermission?.actions.includes(Actions.CHANGE) ?? false,
      edit: userManagementPermission?.actions.includes(Actions.EDIT) ?? false,
      delete:
        userManagementPermission?.actions.includes(Actions.DELETE) ?? false,
    };
  });

  rolePermissions = computed(() => {
    if (!this.currentUser?.userRole?.permissions?.desktop) {
      return {
        edit: false,
        delete: false,
      };
    }

    const roleManagementPermission =
      this.currentUser.userRole.permissions.desktop.find(
        (p) => p.resource === ClientModules.ROLES_MANAGEMENT,
      );

    return {
      edit: roleManagementPermission?.actions.includes(Actions.EDIT) ?? false,
      delete:
        roleManagementPermission?.actions.includes(Actions.DELETE) ?? false,
    };
  });

  formsPermissions = computed(() => {
    if (!this.currentUser?.userRole?.permissions?.desktop) {
      return {
        create: false,
        edit: false,
        assign: false,
        delete: false,
      };
    }

    const formBuilderPermission =
      this.currentUser.userRole.permissions.desktop.find(
        (p) => p.resource === ClientModules.FORM_BUILDER,
      );

    return {
      create: formBuilderPermission?.actions.includes(Actions.CREATE) ?? false,
      edit: formBuilderPermission?.actions.includes(Actions.EDIT) ?? false,
      assign: formBuilderPermission?.actions.includes(Actions.ASSIGN) ?? false,
      delete: formBuilderPermission?.actions.includes(Actions.DELETE) ?? false,
    };
  });

  hasPermission(resource: ClientModules, action: Actions): boolean {
    if (!this.currentUser?.userRole?.permissions?.desktop) return false;

    const permission = this.currentUser.userRole.permissions.desktop.find(
      (p) => p.resource === resource,
    );

    return permission?.actions.includes(action) ?? false;
  }
}
